import { render } from "./SpeakerList.vue?vue&type=template&id=28ba2954&scoped=true"
import script from "./SpeakerList.vue?vue&type=script&lang=js"
export * from "./SpeakerList.vue?vue&type=script&lang=js"

import "./SpeakerList.vue?vue&type=style&index=0&id=28ba2954&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ba2954"]])

export default __exports__